import React from 'react';
import PropTypes from 'prop-types';
import Storeys from '../../../../../classes/common/storeys';

function Building (props) {
  const item = props.item;
  const property = item.getProperty();
  const room = property.getRoom();
  const building = property.getBuilding();
  const infrastructure = property.getInfrastructure();
  const dealCondition = item.getDealCondition();

  const floor = room.getFloorNumber();
  const furniture = room.getFurniture();
  const totalFloors = building.getFloorsNumberAboveGround();
  const buildingType = building.getType();
  const material = building.getMaterial();
  const storeys = new Storeys(floor, totalFloors);

  return (
    // TODO: добавить "жилое/нежилое"
    <td className='col-building'>
      {
        (floor || totalFloors /* && dealType !== 'rentDaily' */) &&
        (<div><span className='main-param'>{storeys.getLabel(Storeys.TYPE_LONG)}</span></div>)
      }
      <div>
        {
          [
            (material && material.get('middleName')),
            (buildingType && buildingType.get('middleName')),
            building.getLabelFirstLine(),
            room.getLabelPrivateEntrance(),
            infrastructure.getLabelSecurityProtection(),
            building.getLabelRepairPit(),
            building.getLabelCellar(),
            building.getLabelElectricity(),
            building.getLabelHeating(),
            building.getLabelWater(),
            building.getLabelCanalization(),
            building.getLabelNewBuilding(),
            building.getDeliveryDateLabel(),

            room.getLabelNumberOfBeds(),
            (furniture && furniture.get('shortName')),
            room.getLabelPhone(),
            room.getLabelFridge(),
            room.getLabelTV(),
            room.getLabelWashingMachine(),
            room.getLabelConditioning(),
            dealCondition.getLabelAnimalsAllow(),

            building.getLabelDetached()
          ].filter(Boolean).map(el => <div key={el}>{el}</div>)
        }
      </div>
    </td>
  );
}

Building.propTypes = {
  item: PropTypes.object.isRequired
};

Building.defaultProps = {};

export default Building;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/GridCells/Building.jsx